export const useScrollToAnchor = (
    inlineAnchor,
    setInlineAnchor,
    anchorPos,
    setAnchorPos,
    scrollRef
) => {
    async function refAnchors() {
        const refAnchorTags: HTMLAnchorElement[] = Array.from(
            document.querySelectorAll(`main a`)
        );
        return refAnchorTags;
    }

    const scrollToElement = async () => {
        try {
            const anchorCollection = await refAnchors();
            const targetAnchor = findTargetAnchor(
                anchorCollection,
                inlineAnchor //inlineAnchor assigned from Article Source list buttons
            );
            if (!targetAnchor) {
                return;
            }
            processScroll(targetAnchor);
        } finally {
            clearAnchorState();
        }
    };

    scrollToElement();

    function findTargetAnchor(anchorCollection, inlineAnchor) {
        //Find all matching article sources to article source links ()
        const targetAnchors = anchorCollection?.filter(
            (anchor) => anchor.hash.substring(1) === inlineAnchor
        ); //return only anchor tags that match inlineAnchor text
        if (targetAnchors?.length === 0) return null;

        if (
            //if there are multiple anchors, anchor scroll position exists and the clicked anchor tag matches inlineAnchor text...
            targetAnchors?.length > 1 &&
            anchorPos?.anchorScrollTop &&
            anchorPos?.anchorRef?.hash.substring(1) === inlineAnchor
        ) {
            //...scroll the page using the scroll position...
            return { anchor: anchorPos?.anchorRef, useScrollPos: true };
        }
        //...otherwise scroll to the element using the anchor element
        return { anchor: targetAnchors[0], useScrollPos: false };
    }

    function processScroll({ anchor, useScrollPos }) {
        if (useScrollPos && anchorPos) {
            scrollRef?.current.scrollTo({
                top: anchorPos?.anchorScrollTop,
                behavior: `smooth`,
            });
            anchorPos?.anchorRef?.focus();
        } else {
            anchor.scrollIntoView({
                behavior: `smooth`,
                block: `center`,
            });
            anchor?.focus();
        }
    }

    function clearAnchorState() {
        setInlineAnchor(null);
        setAnchorPos(null);
    }
};
